import * as React from "react";
import { Accordion } from "react-bootstrap";
import { ListGroup } from "react-bootstrap";
import Questions from "../components/Forum/Questions"
import InputBox from "../components/Forum/InputBox";


export default function Discussions() {
  return (
    <>

      <InputBox />
      <Questions />
     
    </>
  );
}
